function capitalize(string) {
  if (typeof string !== 'string') {
    throw new Error('Input must be a string');
  }

  return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
}

function isNonEmptyString(string) {
  return typeof string === 'string' && string.trim() !== '';
}

function limitStringLength(string = '', maxLength) {
  if (typeof string !== 'string') {
    throw new Error('Input must be a string');
  }

  if (typeof maxLength !== 'number' || maxLength < 4) {
    throw new Error('maxLength must be a positive number bigger or equal than 4');
  }

  if (string.length > maxLength) {
    return `${string.slice(0, maxLength - 3)}...`;
  }
  return string;
}

module.exports = {
  capitalize,
  isNonEmptyString,
  limitStringLength
};
